export { default } from '@klokhuis/modules/Commons/pages/AgentsKnowledgeHub/AgentsKnowledgeHub.page';
